import { getAuthCookiesHelper } from "@warda/library-ui/contexts/AppCookiesContext";
// https://wardafactory.atlassian.net/browse/SEECOMM-7901
const authCookiesHelper = getAuthCookiesHelper();
export default authCookiesHelper;
